/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Androidbeta_Meta_Description1Inputs */

const id_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikuti program pengujian beta tertutup aplikasi Android egdata.app`)
};

const ms_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertai program ujian beta tertutup aplikasi Android egdata.app`)
};

const da_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deltag i egdata.app Android app lukket beta-testprogram`)
};

const de_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nehmen Sie am geschlossenen Beta-Testprogramm der egdata.app Android-App teil`)
};

const en_us2_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join the egdata.app Android app closed beta testing program`)
};

const es_es2_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete al programa de pruebas beta cerradas de la app Android de egdata.app`)
};

const es_mx2_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Únete al programa de pruebas beta cerradas de la aplicación Android de egdata.app`)
};

const fil_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumali sa closed beta testing program ng egdata.app Android app`)
};

const fr_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoignez le programme de test bêta fermé de l'application Android egdata.app`)
};

const it_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partecipa al programma di beta testing chiuso dell'app Android egdata.app`)
};

const hu_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csatlakozz az egdata.app Android alkalmazás zárt béta tesztelési programjához`)
};

const nl_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem deel aan het gesloten bètatestprogramma van de egdata.app Android-app`)
};

const no_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bli med i egdata.app Android-appens lukkede betatestprogram`)
};

const pl_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dołącz do zamkniętego programu testów beta aplikacji Android egdata.app`)
};

const pt_br2_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Participe do programa de testes beta fechado do aplicativo egdata.app Android`)
};

const pt_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Junte-se ao programa de testes beta fechado da app Android egdata.app`)
};

const ro_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alătură-te programului de testare beta închisă a aplicației Android egdata.app`)
};

const fi_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liity egdata.app Android -sovelluksen suljettuun beta-testausohjelmaan`)
};

const sv_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gå med i egdata.app Android-appens slutna betatestprogram`)
};

const vi_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tham gia chương trình thử nghiệm beta kín ứng dụng Android egdata.app`)
};

const tr_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Android uygulaması kapalı beta test programına katılın`)
};

const cs_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Připojte se k programu uzavřeného beta testování Android aplikace egdata.app`)
};

const bg_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присъединете се към програмата за затворено бета тестване на Android приложението egdata.app`)
};

const ru_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Присоединяйтесь к программе закрытого бета-тестирования Android-приложения egdata.app`)
};

const uk_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приєднуйтеся до програми закритого бета-тестування Android-застосунку egdata.app`)
};

const ar_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انضم إلى برنامج الاختبار التجريبي المغلق لتطبيق Android egdata.app`)
};

const hi_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android ऐप क्लोज्ड बीटा में शामिल हों`)
};

const th_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าร่วมโปรแกรมทดสอบเบต้าแบบปิดของแอป Android egdata.app`)
};

const ja_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Android アプリのクローズドベータテストプログラムに参加`)
};

const zh_cn2_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入 egdata.app Android应用内测计划`)
};

const zh_hant1_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加入 egdata.app Android應用內測計畫`)
};

const ko_misc_androidbeta_meta_description1 = /** @type {(inputs: Misc_Androidbeta_Meta_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`egdata.app Android 앱 클로즈드 베타 테스트 프로그램에 참여하세요`)
};

/**
* | output |
* | --- |
* | "Join the egdata.app Android app closed beta testing program" |
*
* @param {Misc_Androidbeta_Meta_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_androidbeta_meta_description1 = /** @type {((inputs?: Misc_Androidbeta_Meta_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Androidbeta_Meta_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_androidbeta_meta_description1(inputs)
	if (locale === "ms") return ms_misc_androidbeta_meta_description1(inputs)
	if (locale === "da") return da_misc_androidbeta_meta_description1(inputs)
	if (locale === "de") return de_misc_androidbeta_meta_description1(inputs)
	if (locale === "en-US") return en_us2_misc_androidbeta_meta_description1(inputs)
	if (locale === "es-ES") return es_es2_misc_androidbeta_meta_description1(inputs)
	if (locale === "es-MX") return es_mx2_misc_androidbeta_meta_description1(inputs)
	if (locale === "fil") return fil_misc_androidbeta_meta_description1(inputs)
	if (locale === "fr") return fr_misc_androidbeta_meta_description1(inputs)
	if (locale === "it") return it_misc_androidbeta_meta_description1(inputs)
	if (locale === "hu") return hu_misc_androidbeta_meta_description1(inputs)
	if (locale === "nl") return nl_misc_androidbeta_meta_description1(inputs)
	if (locale === "no") return no_misc_androidbeta_meta_description1(inputs)
	if (locale === "pl") return pl_misc_androidbeta_meta_description1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_androidbeta_meta_description1(inputs)
	if (locale === "pt") return pt_misc_androidbeta_meta_description1(inputs)
	if (locale === "ro") return ro_misc_androidbeta_meta_description1(inputs)
	if (locale === "fi") return fi_misc_androidbeta_meta_description1(inputs)
	if (locale === "sv") return sv_misc_androidbeta_meta_description1(inputs)
	if (locale === "vi") return vi_misc_androidbeta_meta_description1(inputs)
	if (locale === "tr") return tr_misc_androidbeta_meta_description1(inputs)
	if (locale === "cs") return cs_misc_androidbeta_meta_description1(inputs)
	if (locale === "bg") return bg_misc_androidbeta_meta_description1(inputs)
	if (locale === "ru") return ru_misc_androidbeta_meta_description1(inputs)
	if (locale === "uk") return uk_misc_androidbeta_meta_description1(inputs)
	if (locale === "ar") return ar_misc_androidbeta_meta_description1(inputs)
	if (locale === "hi") return hi_misc_androidbeta_meta_description1(inputs)
	if (locale === "th") return th_misc_androidbeta_meta_description1(inputs)
	if (locale === "ja") return ja_misc_androidbeta_meta_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_androidbeta_meta_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_androidbeta_meta_description1(inputs)
	return ko_misc_androidbeta_meta_description1(inputs)
});
export { misc_androidbeta_meta_description1 as "misc.androidBeta.meta.description" }